<template>
	<div class="main">
		<a-table
			:columns="columns"
			:dataSource="dataSource"
			:pagination="false"
			row-key="id"
			:rowClassName="changecolor"
			:row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
		>
			<template v-slot:tindex="_,__,index">
				{{ index+1 }}
			</template>
			<template v-slot:bokuan="text">
				{{ text==1?"已拨款":"未拨款" }}
			</template>
			<template v-slot:action="id,record">
				<slot name="tAction" :id="id" :record="record"></slot>
				<a-divider type="vertical" />
				<a class="tAction" v-if="(record.type == 8||record.type == 9 )&& record.status == 3" @click="showsunhaofn(id,record.hetonglingquinfo)">损耗</a>
			</template>
		</a-table>
		<Sunhao ref="sunhaoref"></Sunhao>
	</div>
</template>

<script>

import {getCailiaodanlist} from "@/api/contract.js"
import {columns} from './data';
import Sunhao from '@/pages/contract/confirm/sunhao.vue';

export default {
	data(){
		return {
			columns,
			dataSource:[],
			loading:false,
			selectedRowKeys:[],
		}
	},
	components:{Sunhao},
	methods:{
		showsunhaofn(id,hetonglingquinfo){
			if(typeof hetonglingquinfo == "string"){
				hetonglingquinfo = JSON.parse(hetonglingquinfo)
			}
			this.$refs.sunhaoref.showsunhao({hetonglingquinfo,id})
		},
		getlist(parm){
			this.loading = true
			return getCailiaodanlist(parm).then(ret=>{
				this.loading = false
                let {rows}= ret.data;
                this.dataSource = rows
				return ret
			})
		},
		getdataSource(){
			return this.dataSource
		},
		onSelectChange(selectedRowKeys){
			this.selectedRowKeys = selectedRowKeys;
		},
		getSlts(){
			return this.selectedRowKeys
		},
		setSlts(slt){
			this.selectedRowKeys = slt
		},
		changecolor(record){
			if(record.isMoneyGive == 1){
				return "moneygive"
			}
			return ""
		},
	}
}
</script>
<style>
.moneygive{
	color: red;
}
</style>


